import { Mic, Users, TrendingUp } from "lucide-react";
import { PublicHeader, Footer } from "../components/PublicChrome";
import { JobBoard } from "../components/careers/JobBoard";
import { TalentPool, TrackApp } from "../components/careers/TalentForms";
import { SectionHead } from "../components/Badges";

const PILLARS = [
  [Mic, "Ghana's most-listened voice", "Work on platforms like Peace FM — reported at ~9.7% audience share — and Kokrokoo, one of Ghana's most influential political programmes."],
  [Users, "One group, many careers", "Media, food processing, finance, hospitality and manufacturing — move across 14 DGC entities as you grow."],
  [TrendingUp, "Built on Ghanaian excellence", "Asante Twi broadcasting heritage meets modern digital, TV and enterprise operations."],
];

export default function Careers() {
  return (
    <div data-testid="careers-page">
      <PublicHeader home={false} />
      <section className="relative overflow-hidden grain">
        <img src="https://images.unsplash.com/photo-1573497019418-b400bb3ab074?w=2000&q=80" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-28 rise">
          <div className="eyebrow mb-4">DESPITE Careers · Recruitment & Talent Portal</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-ink max-w-3xl leading-[1.05]">Build the voice of <span className="text-gold">Ghana</span> with us.</h1>
          <p className="text-slate-300 mt-6 max-w-xl">Every open role across the Despite Group — in one place. Apply in minutes, track your progress, or join our talent community.</p>
          <div className="mt-8 flex gap-3"><a href="#jobs" className="btn-gold" data-testid="careers-browse-btn">Browse open roles</a><a href="#pool" className="btn-ghost" data-testid="careers-pool-btn">Join talent pool</a></div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-3 gap-4" data-testid="employer-branding">
        {PILLARS.map(([I, t, d]) => (
          <div key={t} className="panel p-6"><I className="text-gold" size={22} /><h3 className="text-ink font-semibold mt-4">{t}</h3><p className="text-sm text-slate-400 mt-2">{d}</p></div>
        ))}
        <div className="md:col-span-3 panel p-6 border-dashed text-sm text-slate-500" data-testid="testimonials-placeholder">
          [Day-in-the-life videos and staff testimonials — to be recorded with real DGC staff. Not found publicly.]
        </div>
      </section>
      <section id="jobs" className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <SectionHead eyebrow="Open roles" title="Find your place at DESPITE">Filter by entity, department, location and language requirement.</SectionHead>
        <JobBoard />
      </section>
      <section id="pool" className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid lg:grid-cols-2 gap-6">
        <TalentPool />
        <TrackApp />
      </section>
      <Footer />
    </div>
  );
}
